import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { DepartamentoCard } from "./DepartamentoCard";
import { paginacion } from "../../utils/paginacion/paginacion";

const DEPARTAMENTOS_POR_PAGINA = 15;

export const DepartamentoList = ({ departamentos = [], onRefresh }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const [busqueda, setBusqueda] = useState("");

  const departamentosFiltrados = departamentos.filter((departamento) => {
    const texto = busqueda.toLowerCase();
    return (
      departamento?.nombre?.toLowerCase().includes(texto) ||
      departamento?.pais?.nombre?.toLowerCase().includes(texto)
    );
  });

  const {
    objetosEnPagina: departamentosEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, departamentosFiltrados, DEPARTAMENTOS_POR_PAGINA);

  const columnas = ["#", "Nombre", "País", "Opciones"];

  const handleDelete = (idDepartamento) => {
    onRefresh?.();
  };

  return (
    <section className="px-4 pb-10 max-w-6xl mx-auto">
      <div className="flex justify-between items-center my-4">
        <input
          type="text"
          placeholder="Buscar por nombre o país..."
          value={busqueda}
          onChange={(e) => {
            setBusqueda(e.target.value);
            setPaginaActual(1);
          }}
          className="border border-gray-300 rounded px-4 py-2 w-full max-w-md"
        />
      </div>

      <DataTable
        columnas={columnas}
        paginas={paginas}
        paginaInicial={paginaInicial}
        paginaFinal={paginaFinal}
        paginaActual={paginaActual}
        setPaginaActual={setPaginaActual}
      >
        {departamentosEnPagina.length === 0 ? (
          <tr>
            <td colSpan={columnas.length} className="text-center py-8 text-gray-500">
              No hay departamentos registrados
            </td>
          </tr>
        ) : (
          departamentosEnPagina.map((departamento, index) => (
            <DepartamentoCard
              key={departamento.idDepartamento}
              departamento={departamento}
              index={paginaInicial + index}
              onDelete={handleDelete}
            />
          ))
        )}
      </DataTable>
    </section>
  );
};